import React from 'react'
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-bg" aria-hidden="true">
        <div className="footer-overlay"></div>
      </div>
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <img
              src="/new-logo-motorcycle.png"
              alt="GW Motorsports LLC Motorcycle Shop Logo"
              className="footer-logo"
            />
            <div>
              <h3 className="footer-name">GW Motorsports LLC</h3>
              <p className="footer-tag">
                Performance motorcycle shop for service and parts installation.
              </p>
            </div>
          </div>

          <div className="footer-contact">
            <a className="contact-row" href="tel:9452862506">
              <span className="contact-icon">
                <img src="/assets/images/phone-call.png" alt="" width={18} />
              </span>
              <div>
                <span className="contact-label">Call</span>
                <span className="contact-value">(945) 286-2506</span>
              </div>
            </a>
            <a className="contact-row" href="mailto:glenn@gwmotorsportsllc.com">
              <span className="contact-icon">
                <img src="/assets/images/email.png" alt="" width={18} />
              </span>
              <div>
                <span className="contact-label">Email</span>
                <span className="contact-value">
                  glenn@gwmotorsportsllc.com
                </span>
              </div>
            </a>
            <a
              className="contact-row"
              href="https://maps.app.goo.gl/V7jHRdJzzZMiNd16A"
              target="_blank"
              rel="noreferrer"
            >
              <span className="contact-icon">
                <img src="/assets/images/map.png" alt="" width={18} />
              </span>
              <div>
                <span className="contact-label">Visit</span>
                <span className="contact-value">
                  313 Panorama Loop
                  <br />
                  Waxahachie, TX 75165
                </span>
              </div>
            </a>
          </div>

          <div className="footer-owner">
            <span className="owner-eyebrow">Owner</span>
            <h3 className="owner-name">Glenn Wright</h3>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} GW Motorsports. All rights reserved.
          </p>
          <p className="credit">
            Website by{" "}
            <a
              href="https://fennerstudios.com"
              rel="noreferrer"
              target="_blank"
            >
              Fenner Studios
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer
